<!-- 財務 -> 应收管理 -> 应付汇总 -->
<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix no_print">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date"
                    placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date"
                    placeholder="结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
                <el-date-picker v-model="arrival_start_time" value-format="yyyy-MM-dd" class="search_time_input"
                    type="date" placeholder="到港开始"></el-date-picker>
                ~
                <el-date-picker v-model="arrival_end_time" value-format="yyyy-MM-dd" class="search_time_input"
                    type="date" placeholder="到港结束"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" placeholder="供应商" multiple
                filterable @visible-change="getSelectsalePurchase('supplier_id')">
                <el-option v-for="list in selectMapS.supplier_id" :key="list.id" :value="list.id"
                    :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.payer_id" placeholder="付款方" multiple
                filterable @visible-change="getSelectList('payerList')">
                <el-option v-for="list in selectMap.payerList" :key="list.id" :value="list.id"
                    :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.deposit_status" multiple
                placeholder="定金状态">
                <el-option :value="999" label="全部状态"></el-option>
                <el-option :value="0" label="未付定金"></el-option>
                <el-option :value="1" label="已付定金"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.settlement_status" multiple
                placeholder="结算状态">
                <el-option :value="999" label="全部状态"></el-option>
                <el-option :value="0" label="未结算"></el-option>
                <el-option :value="1" label="已结算"></el-option>
                <el-option :value="2" label="部分结算"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.status" multiple placeholder="合同状态">
                <el-option :value="999" label="全部状态"></el-option>
                <el-option :value="0" label="未完成"></el-option>
                <el-option :value="1" label="已完成"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.foreign_currency_id"
                multiple collapse-tags placeholder="币种:" @visible-change="getSelectList('currency')">
                <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                    :label="list.name"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn"
                    @click="filterDialogVisible=!filterDialogVisible;scene='cloud.finance.payments';isGlobal=false;filter=filter;">
                </div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList no_print clearfix">
            <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="payFunc">付款</el-button> -->
            <el-button class="funcPublicBtn" @click="payDeposit">付定金</el-button>
            <el-button class="funcPublicBtn" @click="payTailDeposit">付尾款</el-button>
            <el-button class="funcPublicBtn" @click="settlement">批量结算</el-button>
            <!-- <el-button class="funcPublicBtn" @click="payOtherDeposit">其他付款</el-button> -->
            <el-button class="funcPublicBtn" @click="payDiscount">添加优惠/赔偿</el-button>
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" :scene="scene" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"
                @rowClick="rowClick" @getRow="getRow"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip" style="width:180px;">
                        <div class="laCbelTipC">
                            在途数量+入库数量
                        </div>
                    </div>
                    <span> 码单数量:{{totalObj.total_cube}}</span>
                </div>
            </div>
            <div class="totalNumber">订单金额:{{totalObj.foreign_currency_total}}</div>
            <div class="totalNumber">预付定金:{{totalObj.foreign_deposit}}</div>
            <div class="totalNumber">订单尾款:{{totalObj.fc_payment_amount}}</div>
            <!-- <div class="totalNumber">应付外币金额:{{totalObj.fc_pay_amount}}</div> -->
            <div class="totalNumber">码单尾款:{{totalObj.bale_foreign_amount}}</div>
            <div class="totalNumber">已结金额:{{totalObj.fc_settlement_amount}}</div>
            <div class="totalNumber">未结金额:{{totalObj.fc_unsettlement_amount}}</div>
            <div class="totalNumber">结汇定金:{{totalObj.rmb_deposit}}</div>
            <!-- <div class="totalNumber">已结金额:{{totalObj.settlement_amount}}</div> -->
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total"
                :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>

        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible"
            class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false"
            :title="'采购单('+form_params.contract_no+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item label="供应商名称：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="合同日期：">
                                <el-date-picker v-model="form_params.contract_time" :disabled="true" type="date"
                                    placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="付款方：">
                                <el-input v-model="form_params.payer" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox">
                            <img src="/icon/operation_edits.png" @click="amend" class="form_edits">
                            <el-form-item label="REC：">
                                <el-checkbox :disabled="true" v-model="form_params.rec"></el-checkbox>
                                <el-input v-model="form_params.tax_rate" :disabled="true" v-if="form_params.rec"
                                    @input="calculationTableTotal(),recDigit($event)" placeholder="税率%："
                                    class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1"
                            @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                    </el-form>
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row
                                size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field"
                                        v-if="item.show && billColumn.includes(item.field)" :key="item.field"
                                        :label="item.name" :sortable="false"
                                        :width="item.width && item.width>0 ?item.width:80+ 'px'" align="left"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                        <div class="dialogTotal clearfix">
                            <div class="dialogTotalC">合计应付</div>
                            <div class="dialogTotalC">
                                <div class="contractLabel" style="position:relative;">
                                    <div class="labelTip" style="top:-80px;">
                                        <div class="laCbelTipC">
                                            <div>北美材模板导入:千板尺*外币单价</div>
                                            <div>其他模板导入:码单立方*外币单价</div>
                                        </div>
                                    </div>
                                    <span> 外币码单金额:{{form_params.fc_amount}}</span>
                                </div>
                            </div>
                            <div class="dialogTotalC">
                                <div class="contractLabel" style="position:relative;">
                                    <div class="labelTip" style="width:180px;">
                                        <div class="laCbelTipC">
                                            <div>码单立方*采购单价</div>
                                        </div>
                                    </div>
                                    <span>采购金额:{{form_params.rmb_amount}}</span>
                                </div>
                            </div>
                            <!-- <div class="dialogTotalC">优惠/赔偿:{{form_params.fc_reduce_amount}}({{form_params.rmb_reduce_amount}})</div> -->
                            <!-- <div class="dialogTotalC">其他应付:{{form_params.fc_other_amount}}({{form_params.rmb_other_amount}})</div> -->

                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark"
                            cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <!-- <div class="editPerson">审核人：{{form_params.auditor_name}}</div> -->
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;" v-if="supplier_balance.fc_balance||supplier_balance.balance">
                        采购余额：{{supplier_balance.fc_balance}} <span
                            style="padding-left: 20px;">{{supplier_balance.balance}}</span>
                        <!-- <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}} -->
                        <!-- <img src="../../assets/top-delete-suspension.png" v-if="form_params.id==''" class="newFeeImg" @click="delOutFee(index)"/> -->
                        <!-- </div>
                        </div> -->
                    </div>
                    <div class="editBtn">
                        <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addDialogVisibleBack = true;add_params.supplier_id = form_params.supplier_id;add_params.ids = [form_params.id];add_params.contract_no = form_params.contract_no;purchaseShow =true">付款</el-button> -->
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="purchaseDeposit">付定金</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="purchaseTail">付尾款</el-button>
                        <el-button class="funcPublicBtn" @click="purchaseSettlement">结算</el-button>
                        <el-button class="funcPublicBtn" @click="openBill">收发票</el-button>
                        <!-- <el-button class="funcPublicBtn" @click="print(8)">合同打印</el-button> -->
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                        <el-button class="funcPublicBtn" @click="exportExcelBill">导出</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag title="付款单" :visible.sync="addDialogVisibleBack" class="eldialog no_print eldialogLine"
            :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="add_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder=""
                            @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="add_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" disabled placeholder="">
                            <el-option :value="0" label="收入"></el-option>
                            <el-option :value="1" label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder=""
                            @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付款金额：">
                        <el-input v-model="add_params.amount" @input.native="changeRate($event,add_params.amount)"
                            placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addDialogVisibleBack=!addDialogVisibleBack">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addOrderSheetBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
        <!-- 付定金 dialog START -->
        <el-dialog ref="deposit_params" v-dialog-drag title="定金付款单" :visible.sync="addDepositDialog"
            class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form ref="deposit_params" :model="deposit_params" :rules="addDialogRules" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="deposit_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="deposit_params.account_id" placeholder=""
                            @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="deposit_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="deposit_params.bill_type" disabled placeholder="">
                            <el-option :value="0" label="收入"></el-option>
                            <el-option :value="1" label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" prop="payment_type_id">
                        <el-select v-model="deposit_params.payment_type_id" placeholder=""
                            @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="deposit_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="外币预付定金：">
                        <el-input v-model="deposit_params.amount" disabled placeholder=""></el-input>
                    </el-form-item> -->
                    <el-form-item label="外币预付定金：" class="dialogTwo clearfix" prop="amount">
                        <el-select class="twoSelect" v-model="deposit_params.currency_id"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <!-- @input="exchangeRate" -->
                        <el-input class="twoInput" @input.native="changeRate($event,deposit_params.amount)"
                            @input="AmountCalculation($event,deposit_params.currency_rate)"
                            v-model="deposit_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="定金汇率：" prop="currency_rate">
                        <el-input v-model="deposit_params.currency_rate"
                            @input="AmountCalculation(deposit_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥金额：">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto;">
                        <span slot="label"><span>付款凭证：</span>
                        </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false"
                            :form-param.sync="deposit_params.files"></ym-upload>
                    </el-form-item>
                    <!-- <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="备注：">
                        <el-input v-model="deposit_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDepositDialog=!addDepositDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addDepositBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 付定金 dialog END -->
        <!-- 尾款付款单 dialog START -->
        <el-dialog v-dialog-drag title="尾款付款单" :visible.sync="addTailDepositDialog"
            class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="tailDeposit_params" ref="add_form" :rules="addDialogRules" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="tailDeposit_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="tailDeposit_params.account_id" placeholder=""
                            @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="tailDeposit_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="tailDeposit_params.bill_type" disabled placeholder="">
                            <el-option :value="0" label="收入"></el-option>
                            <el-option :value="1" label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" prop="payment_type_id">
                        <el-select v-model="tailDeposit_params.payment_type_id" placeholder=""
                            @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="tailDeposit_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="外币尾款：" class="dialogTwo clearfix" prop="amount">
                        <el-select class="twoSelect" v-model="tailDeposit_params.currency_id"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <!-- @input="exchangeRate" -->
                        <el-input class="twoInput" @input.native="changeRate($event,tailDeposit_params.amount)"
                            @input="AmountCalculation($event,tailDeposit_params.currency_rate)"
                            v-model="tailDeposit_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label=" 尾款汇率：" prop="currency_rate">
                        <el-input v-model="tailDeposit_params.currency_rate"
                            @input="AmountCalculation(tailDeposit_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥金额：">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto;">
                        <span slot="label"><span>付款凭证：</span>
                        </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false"
                            :form-param.sync="tailDeposit_params.files"></ym-upload>
                    </el-form-item>
                    <!-- <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="备注：">
                        <el-input v-model="tailDeposit_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addTailDepositDialog=!addTailDepositDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addTailDepositBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 尾款付款单 dialog END -->
        <!-- 结算确认单 dialog START -->
        <el-dialog v-dialog-drag title="结算确认" :visible.sync="addSettlementDialog" class="eldialog no_print eldialogLine"
            :modal="false" custom-class="full_dialog">
            <el-form :model="settlement_params" ref="add_form" :rules="addRules" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="结算日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结算方式：">
                        <el-select v-model="settlement_params.type" placeholder="" @change="currencyChange"
                            @visible-change="getSelectList('settlementType')">
                            <el-option v-for="item in selectMap.settlementType" :key="item.id" :value="item.id"
                                :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购余额：" class="other_form_item" v-if="settlement_params.type==1">
                        <div style="text-align:left;">{{purchaseBalance}}</div>
                    </el-form-item>
                    <el-form-item label="优惠赔偿金：" class="other_form_item" v-if="settlement_params.type==2">
                        <div style="text-align:left;">{{reduceAmount}}</div>
                    </el-form-item>
                    <el-form-item label="未结金额：" class="other_form_item">
                        <div style="text-align:left;">{{amountPayable}}</div>
                    </el-form-item>
                    <el-form-item label="结算金额：" class="dialogTwo clearfix">
                        <el-select class="twoSelect" v-model="settlement_params.currency_id" @change="currencyChange"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" @input.native="changeRate($event,settlement_params.amount)"
                            @input="AmountCalculation($event,settlement_params.currency_rate)"
                            v-model="settlement_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label=" 汇率：" v-if="settlement_params.type==2" prop="currency_rate">
                        <el-input v-model="settlement_params.currency_rate" :disabled="isRenminbi"
                            @input="AmountCalculation(settlement_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥金额：" v-if="settlement_params.type==2">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="settlement_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addSettlementDialog=!addSettlementDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addsettlementBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 结算确认单 dialog END -->
        <!-- 其他付款单 dialog START -->
        <el-dialog v-dialog-drag title="其他付款单" :visible.sync="addOtherDepositDialog"
            class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="otherDeposit_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="otherDeposit_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="otherDeposit_params.account_id" placeholder=""
                            @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="otherDeposit_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="otherDeposit_params.bill_type" disabled placeholder="">
                            <el-option :value="0" label="收入"></el-option>
                            <el-option :value="1" label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：">
                        <el-select v-model="otherDeposit_params.payment_type_id" placeholder=""
                            @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="费用名称：">
                        <el-input v-model="otherDeposit_params.fee_name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="外币金额：" class="dialogTwo clearfix" prop="foreign_currency_amount">
                        <el-select class="twoSelect" v-model="otherDeposit_params.currency_id"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" @input.native="changeRate($event,otherDeposit_params.amount)"
                            @input="AmountCalculation($event,otherDeposit_params.currency_rate)"
                            v-model="otherDeposit_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label=" 汇率：">
                        <el-input v-model="otherDeposit_params.currency_rate"
                            @input="AmountCalculation(otherDeposit_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥付款金额：">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto;">
                        <span slot="label"><span>付款凭证：</span>
                        </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false"
                            :form-param.sync="otherDeposit_params.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="otherDeposit_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addOtherDepositDialog=!addOtherDepositDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addotherDepositBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 其他付款单 dialog END -->
        <!-- 添加优惠/赔偿 dialog START -->
        <el-dialog v-dialog-drag title="添加优惠/赔偿" :visible.sync="addDiscountDialog"
            class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="discount_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="discount_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="discount_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="外币金额：" class="dialogTwo clearfix" prop="foreign_currency_amount">
                        <el-select class="twoSelect" v-model="discount_params.currency_id"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" @input.native="changeRate($event,discount_params.amount)"
                            @input="AmountCalculation($event,discount_params.currency_rate)"
                            v-model="discount_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto;">
                        <span slot="label"><span>凭证：</span>
                        </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false"
                            :form-param.sync="discount_params.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="discount_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDiscountDialog=!addDiscountDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addDiscountBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 添加优惠/赔偿 dialog END -->
        <!-- 规格详情 START -->
        <el-dialog v-dialog-drag :visible.sync="specDetailFlag" class="eldialog specTable" width="780px" :modal="false"
            title="详细规格及采购单价" custom-class="full_dialog">
            <el-table :data="specDetail" border stripe highlight-current-row size="mini" height="100%"
                style="max-height:400px">
                <el-table-column label="品名" prop="breed" show-overflow-tooltip></el-table-column>
                <el-table-column label="厚度" prop="thickness" show-overflow-tooltip></el-table-column>
                <el-table-column label="等级" prop="grade" show-overflow-tooltip></el-table-column>
                <el-table-column label="板尺" prop="plate_ruler" show-overflow-tooltip></el-table-column>
                <el-table-column label="外币单价" prop="foreign_currency_price" show-overflow-tooltip></el-table-column>
                <el-table-column label="码单立方" prop="cube" show-overflow-tooltip></el-table-column>
                <el-table-column label="采购单价" prop="cube_price" show-overflow-tooltip></el-table-column>
                <el-table-column label="件数" prop="number" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;display: flex;">
                    <span>合计：板尺：{{cubeTotal.plate_ruler}}</span>
                    <span style="padding-left: 25px;">
                        <div class="contractLabel" style="position:relative;">
                            <div class="labelTip">
                                <div class="laCbelTipC">
                                    <div>北美材模板导入:千板尺*外币单价</div>
                                    <div>其他模板导入:码单立方*外币单价</div>
                                </div>
                            </div>
                            <span>码单金额：{{cubeTotal.foreign_currency_amount}}</span>
                        </div>
                    </span>
                    <span style="padding-left: 25px;">码单立方：{{cubeTotal.cube}}</span>
                    <span style="padding-left: 25px;">
                        <div class="contractLabel" style="position:relative;">
                            <div class="labelTip" style="width:180px;">
                                <div class="laCbelTipC">
                                    <div>码单立方*采购单价</div>
                                </div>
                            </div>
                            <span>采购金额:{{cubeTotal.cube_amount}}</span>
                        </div>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 规格详情 END -->
        <!-- 优惠/赔偿详情 START -->
        <el-dialog v-dialog-drag :visible.sync="discountDetailFlag" class="eldialog specTable" width="820px"
            :modal="false" title="优惠/赔偿详情" custom-class="full_dialog">
            <el-table :data="discountDetail" border stripe highlight-current-row size="mini" height="100%"
                style="max-height:400px">
                <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column key="2" label="操作" width="50">
                    <template slot-scope="scope">
                        <div class="icon_wrap">
                            <i class="operation_delete" @click="discountDetailDelete(scope.$index,scope.row.id)"
                                title="删除"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="添加日期" prop="fee_date" show-overflow-tooltip></el-table-column>
                <el-table-column label="外币金额" prop="fc_currency_unit" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作人" prop="creator_name" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="费用名称" prop="fee_name" show-overflow-tooltip></el-table-column> -->
                <!-- <el-table-column label="汇率" prop="fc_rate" show-overflow-tooltip></el-table-column>
                <el-table-column label="￥赔偿/优惠" prop="amount" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="凭证" width="70px">
                    <template slot-scope="scope">
                        <viewer :images="scope.row.files">
                            <img v-for="(src,index) in scope.row.files" v-show="index < 1" class="viewImg" :src="src"
                                :key="index" />
                        </viewer>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <span>合计：外币金额：{{discountTotal.fc_amount}}</span>
                </div>
            </div>
        </el-dialog>
        <!-- 优惠/赔偿详情 END -->
        <!-- 其他应付详情 START -->
        <el-dialog v-dialog-drag :visible.sync="otherDetailFlag" class="eldialog specTable" width="820px" :modal="false"
            title="其他付款详情" custom-class="full_dialog">
            <el-table :data="otherDetail" border stripe highlight-current-row size="mini" height="100%"
                style="max-height:400px">
                <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column key="2" label="操作" width="50">
                    <template slot-scope="scope">
                        <div class="icon_wrap">
                            <i class="operation_delete" @click="otherDetailDelete(scope.$index,scope.row.id)"
                                title="删除"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="添加日期" prop="trading_time" show-overflow-tooltip></el-table-column>
                <el-table-column label="费用名称" prop="course_title" show-overflow-tooltip></el-table-column>
                <el-table-column label="外币金额" prop="currency_unit" show-overflow-tooltip></el-table-column>
                <el-table-column label="汇率" prop="currency_rate" show-overflow-tooltip></el-table-column>
                <el-table-column label="￥金额" prop="rmb_amount" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作人" prop="operator_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="凭证" prop="files" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <viewer :images="scope.row.files">
                            <img v-for="(src,index) in scope.row.files" v-show="index < 1" class="viewImg" :src="src"
                                :key="index" />
                        </viewer>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="产品图片" width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <viewer :images="scope.row.file"> 
                            <img v-for="(src,index) in scope.row.file" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                    </viewer>
                    </template>
                </el-table-column> -->

            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <span>合计：外币金额：{{otherTotal.fc_amount}}</span>
                    <span style="padding-left: 25px;">金额：{{otherTotal.amount}}</span>
                </div>
            </div>
        </el-dialog>
        <!-- 其他应付详情 END -->
        <!-- 优惠/赔偿详情 START -->
        <el-dialog v-dialog-drag :visible.sync="settlementDiscountDetailFlag" class="eldialog specTable" width="820px"
            :modal="false" title="已结优惠/赔偿详情" custom-class="full_dialog">
            <el-table :data="settlementDiscountDetail" border stripe highlight-current-row size="mini" height="100%"
                style="max-height:400px">
                <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="结算时间" width="100px" prop="trading_time" show-overflow-tooltip></el-table-column>
                <el-table-column label="科目名称" prop="course_title" show-overflow-tooltip></el-table-column>
                <el-table-column label="结算类型" prop="payment_type_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="货币符号" prop="currency_unit" show-overflow-tooltip></el-table-column>
                <el-table-column label="结算金额" prop="settlement_amount" show-overflow-tooltip></el-table-column>
                <el-table-column label="汇率" prop="currency_rate" show-overflow-tooltip></el-table-column>
                <el-table-column label="结算人民币金额" width="120px" prop="rmb_settlement_amount"
                    show-overflow-tooltip></el-table-column>
                <el-table-column label="操作人" prop="operator_name" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <!-- <div style="padding: 5px;font-size: 15px;">
                    <span>合计：外币金额：{{settlementDiscountTotal.fc_amount}}</span>
                    <span style="padding-left: 25px;">费用金额：{{settlementDiscountTotal.amount}}</span>  
                </div> -->
            </div>
        </el-dialog>
        <!-- 优惠/赔偿详情 END -->
        <!-- 开发票 dialog START -->
        <el-dialog v-dialog-drag title="收票" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine"
            :modal="false" custom-class="full_dialog">
            <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票抬头：">
                        <el-input v-model="add_billParams.title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票名称：">
                        <el-input v-model="add_billParams.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票号码：">
                        <el-input v-model="add_billParams.code" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票金额：">
                        <el-input v-model="add_billParams.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="采购单号：">
                        <el-input v-model="add_billParams.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_billParams.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
            </div>
        </el-dialog>
        <!-- 开发票 dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="cloud.finance.payments" :filterDialogVisible="filterDialogVisible"
            @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据里面列配置 START -->
        <filter-fields :tableData="filters" scene="cloud.finance.purchase.info" :isGlobal="isGlobal"
            :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm"
            @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!--查看已开票 START-->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleBill" class="eldialog eldialogStock" width="920px"
            :modal="false" title="开票记录" custom-class="full_dialog">
            <pay-list-dialog ref="selectStock" :id="seeBillList_id" :type="2"></pay-list-dialog>
        </el-dialog>
        <!--查看已开票 END-->
        <!--REC START -->
        <el-dialog v-dialog-drag title="税金修改" :visible.sync="recChanges" width="350px" class="eldialog" :model="false"
            custom-class="full_dialog">
            <el-form :model="rec_params" :inline="true" label-width="70px" class="demo-form-inline" size="mini">
                <el-form-item label="REC:">
                    <el-checkbox class="taxCheck" v-model="f_rec" style="margin-right: 10px;"></el-checkbox>
                    <!-- <el-input  v-model="rec_params.tax_rate"  style="width:145px;" v-digits:4="rec_params.tax_rate" @input="change($event)" class="formInput tax_rate">
                    </el-input>
                    <span style="position: absolute;right: 5px;">%</span> -->
                </el-form-item>
                <!-- <el-form-item label="税金金额:" >
                    <el-input class="formInput" v-model="rec_params.recTax_amount" readonly></el-input>
                </el-form-item>
                <el-form-item label="备注:">
                    <textarea style="width: 180px;min-height: 60px;" class="edit_input edit_textarea formInput" v-model="rec_params.remark">
                    </textarea>
                </el-form-item> -->
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="settlementConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="outRecChanges()">取消</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
        <!-- 列表修改 dialog START -->
        <el-dialog v-dialog-drag title="其他付款修改" :visible.sync="otherVisible" width="460px !important"
            class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="其他付款" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.other_amount"
                            @input.native="changeOther($event,listDetailObj.other_amount)" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"
                    v-model="listDetailObj.other_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button class="publicBtn dialogBtn" @click="otherChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outOtherVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog v-dialog-drag title="优惠修改" :visible.sync="reduceVisible" width="460px !important"
            class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="优惠" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.reduce_amount"
                            @input.native="changeReduce($event,listDetailObj.reduce_amount)" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"
                    v-model="listDetailObj.reduce_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button class="publicBtn dialogBtn" @click="reduceChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outReduceVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .piaoMess {
        font-size: 12px;
        color: #777;
        margin-bottom: 10px;
    }

    .piaoMessC {
        float: left;
        width: 50%;
    }

    .order_header {
        font-size: 26px;
        font-weight: bold;
        line-height: 37px;
        color: #333333;
        text-align: center;
        position: relative;
        top: 15px;

        .code {
            left: 50%;
            position: absolute;
            margin-left: 154px;
            font-size: 12px;
            color: #333333;
        }
    }

    .bottom_flex {
        padding-right: 12px;
        padding-bottom: 8px;
    }

    .editPayBox {
        .editPay {
            width: 50%;
            float: left;
            height: 100px;
            box-sizing: border-box;
            padding: 10px;
        }

        .editName {
            font-size: 12px;
            color: #777;
            padding: 2px 0;
        }

        .editPay:nth-child(2n) {
            border-left: 1px solid #ccc;
        }
    }

    .editPersonBox {
        .editPerson {
            width: 33%;
            float: left;
            font-size: 12px;
            color: #777;
            box-sizing: border-box;
            padding: 5px 0;
        }
    }

    .editBtnList {
        padding-top: 10px;

        .editTax {
            float: left;
            margin-right: 20px;
        }

        .editTaxname {
            float: left;
            font-size: 12px;
            color: #777;
            line-height: 25px;
            margin-right: 5px;
        }

        .editTaxinput {
            float: left;
            width: 100px;
        }

        .editBtn {
            float: right;
        }
    }

    .sub_container {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        text-align: left;
        height: 100%;
        background-color: #fff;

        .filter_path {
            padding: 15px;
            background-color: #F4F5F9;
            margin-bottom: 12px;

            .form-inline {
                &>div {
                    margin-right: 20px;

                    button {
                        margin-left: 15px;
                    }
                }
            }

            .filter_input {
                width: 123px;
            }
        }

        .operate_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 0 6px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            // }
        }

        .table_path {
            flex: 1;
        }

        .statistics {
            background: #F7F8FA;
            padding: 12px 23px;
            line-height: 18px;
            margin-top: 10px;
            display: flex;
            align-items: flex-start;
            font-size: 15px;
            color: #333333;

            &>div:last-child {
                flex: 1;
                margin-left: 26px;

                &>div:last-child {
                    margin-top: 17px;
                }

                &>div>span+span {
                    margin-left: 80px;
                }
            }
        }

        // dialog START
        .order_header {
            font-size: 26px;
            font-weight: bold;
            line-height: 37px;
            color: #333333;
            text-align: center;
            position: relative;
            top: 15px;

            .code {
                left: 50%;
                position: absolute;
                margin-left: 154px;
                font-size: 12px;
                color: #333333;
            }
        }

        .order_dialog {
            .edit_select {
                width: 151px;
            }

            .edit_input {
                width: 116px;
            }

            .order_base {
                margin-bottom: 15px;
            }

            .flex {
                display: flex;
                align-items: center;
                justify-content: space-between;

                &>div {
                    margin-bottom: 12px;
                }

                .edit_input {
                    width: 151px;
                }
            }

            .order_other {
                display: flex;
                align-items: stretch;
                border: 1px solid #707070;
                border-left: 0px none;

                &>div {
                    flex: 1;
                    border-left: 1px solid #707070;
                }

                &>div:first-child {
                    padding: 11px 0 9px 50px;
                }

                .label_no_padding_form>div {
                    margin-bottom: 4px;
                }

                .bottom_flex {
                    display: flex;
                    padding-right: 12px;
                    padding-bottom: 8px;
                }
            }

            .order_footer {
                display: flex;
                font-size: 16px;
                line-height: 22px;
                display: flex;
                padding: 8px 28px 0 32px;
                align-items: center;
                justify-content: space-between;
            }
        }

        .dialog-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            color: #333333;
        }

        // dialog END
        // add_dialog START
        .add_dialog_form {
            &>div {
                margin-bottom: 9px;
            }

            .btn_row {
                padding-top: 23px;
                text-align: center;
            }

            .edit_input {
                width: 100%;
            }
        }

        // add_dialog END
        // sure_dialog START
        .sure_dialog_form {
            &>div {
                margin-bottom: 15px;
            }

            .btn_row {
                padding-top: 23px;
                text-align: right;
            }

            .remark {
                display: flex;
                align-items: stretch;
                justify-content: space-between;
                background: #fff;
                color: #000000;
                font-size: 12px;
                padding: 5px 12px;

                textarea {
                    background: #FFFFFF;
                    border-radius: 3px;
                    height: 84px;
                    resize: none;
                    border: 0px none;
                    outline: none;
                    flex: 1;
                }
            }
        }

        // sure_dialog END
    }

    .form_edits {
        width: 20px;
        position: absolute;
        left: 20px;
    }

    .contractLabel:hover {
        cursor: pointer;
        color: #b21111;
    }

    .contractLabel:hover .labelTip {
        display: block;
    }

    .labelTip {
        display: none;
        position: absolute;
        font-weight: 600;
        top: -65px;
        left: -50px;
        z-index: 1;
        width: 280px;
        text-align: left;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 1px 5px #ccc;
        padding-left: 30px;
        z-index: 100;
        background-color: #000;
        opacity: 0.8;
        color: aliceblue;
    }
</style>
<script>
    import bus from "../../eventBus";
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components: {
            pagination,
            tabletem
        },
        data() {
            return {
                companyName: localStorage.dw_erp_company_name,
                dialogVisibleBill: false,
                seeBillList_id: "",
                tableLoading: false,
                billColumn: "",
                listDetail: [],
                supplier_balance: {},
                dialogVisible: false,
                printDetail: {
                    fields: "",
                    statistic: {
                        total_count: "",
                        total_amount: "",
                        total_cube: ""
                    }
                },
                printTotal: [],
                companyName: localStorage.dw_erp_company_name,
                addDialogVisibleBill: false,
                add_billParams: {
                    // id:"",
                    // invoice_yes:""
                    invoice_time: "",
                    title: "",
                    purchase_id: "",
                    contract_no: "",
                    name: "增值税专用发票",
                    code: "",
                    amount: "",
                    remark: ""
                },

                module: localStorage.dw_erp_power_code,
                enableConfig: localStorage.dw_erp_enable_config,
                boardAmericaType: localStorage.dw_erp_board.indexOf("board-america") != -1 ? true : false,
                boardAfricaType: localStorage.dw_erp_board.indexOf("board-africa") != -1 ? true : false,
                isShowMore: false,
                isGlobal: false,
                companyName: localStorage.dw_erp_company_name,
                scene: "cloud.finance.payments",
                start_time: "",
                end_time: "",
                arrival_start_time: "",
                arrival_end_time: "",
                params: {
                    page: 1,
                    per_page: 50,
                    start_time: "",
                    end_time: "",
                    arrival_start_time: "",
                    arrival_end_time: "",
                    contract_no: "",
                    supplier_id: "",
                    creator_id: "",
                    status: "",
                    status: "",
                },
                last_page: 10,
                total: 0,
                list: [],
                selectMap: {
                    customer: [],
                    creater: [],
                    account: [],
                    paymentType: [],
                    lockLevel: [],
                    currency: [],
                    payerList: [],
                    purchaseCost: [],
                    settlementType: [],
                    currency: [],
                },
                selectMapS: {
                    supplier_id: [],
                },
                // 新增收款单 dialog START
                order_sn: "",
                trading_time: new Date(),
                add_params: {
                    ids: [],
                    contract_no: "",
                    trading_time: "",
                    account_name: "",
                    supplier_id: "",
                    payment_type_id: "",
                    bill_type: 1,
                    course_title: "进销贷款",
                    amount: "",
                    is_invoice: "",
                    remark: ""
                },
                // 新增收款单 dialog END
                // dialog START
                addDialogVisibleBack: false,
                // form_params:{
                //     id:"",
                //     auditor_name: "",
                //     contract_no: "",
                //     contract_time: "",
                //     creator_name: "",
                //     cube: "",
                //     details: [],
                //     order_count: "",
                //     remarks: [],
                //     supplier: ""
                // },
                newFee: [],
                form_params: {
                    id: "",
                    supplier: "",
                    contract_time: "",
                    linkman: "",
                    phone: "",
                    remark: "",
                    is_request_review: 0,
                    tax_rate: "",
                    rec: 0,
                    details: [],
                    fee_list: []
                },
                invoice_time: "",
                // DIALOG END
                tableCol: [
                    { colName: "采购合同号", colKey: "contract_no", colWidth: 190, isSetWidth: true, isCanClick: true, isShow: true, isColor: true },
                    { colName: "合同状态", colKey: "status_text", colWidth: 95, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "合同日期", colKey: "contract_time", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "供应商名称", colKey: "supplier", colWidth: 110, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    // {colName:"品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    { colName: "合同数量", colKey: "cube", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "入库数量", colKey: "storage_number", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "在途数量", colKey: "transit_number", colWidth: 70, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "¥码单金额", colKey: "rmb_amount", colWidth: 85, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "¥已付尾款", colKey: "payment_amount", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "未执行数量", colKey: "norun_number", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币订单金额", colKey: "foreign_currency_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true, },
                    { colName: "外币预付定金", colKey: "foreign_deposit", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true, },
                    { colName: "¥其他应付", colKey: "other_amount", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true, isColor: true, isHideShowClickImg: true, isHideCanClickColor: true, isCanClickUnInclude: ',0,' },
                    { colName: "定金汇率", colKey: "currency_rate", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "收发票", colKey: "invoice_yes", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "¥预付定金", colKey: "rmb_deposit", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币码单金额", colKey: "foreign_total_amount", colWidth: 170, isSetWidth: true, isCanClick: true, isShow: true, isColor: true, isHideShowClickImg: true, isHideCanClickColor: true, },
                    { colName: "制单人", colKey: "creator_name", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币码单尾款", colKey: "foreign_bale_unpay_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币订单尾款", colKey: "foreign_unpay_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "备注", colKey: "remark", colWidth: 150, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币已付尾款", colKey: "fc_payment_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "付款记录", colKey: "see", colWidth: 85, isSetWidth: true, isCanClick: true, isShow: true, isColor: true },
                    { colName: "尾款汇率", colKey: "balance_rate", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币应付金额", colKey: "fc_pay_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币已结金额", colKey: "fc_settlement_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "外币未结金额", colKey: "fc_unsettlement_amount", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "已结优惠/赔偿", colKey: "settlement_reduce", colWidth: 170, isSetWidth: true, isCanClick: true, isShow: true, isColor: true, isHideShowClickImg: true, isHideCanClickColor: true, },
                    { colName: "外币优惠/赔偿", colKey: "fc_reduce_amount", colWidth: 170, isSetWidth: true, isCanClick: true, isShow: true, isColor: true, isHideShowClickImg: true, isHideCanClickColor: true, },
                    // {colName:"其他付款",colKey:"fc_other_amount",colWidth:170,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true,},
                    { colName: "付款方", colKey: "payer", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "币种", colKey: "foreign_currency_name", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "尾款汇率", colKey: "fc_currency_rate", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    { colName: "预计到港", colKey: "expected_arrival_time", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, isColor: true },
                    // {colName:"未付金额",colKey:"un_payment_amount",colWidth:90,htmlNodeFunc(row) {
                    //         let _color = row['un_payment_amount_color'];
                    //         return `<span style="color:${_color}">${row[this.colKey]}</span>`;
                    //     },isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"付款状态",colKey:"pay_status_text",colWidth:90,isSetWidth:true},
                    // {colName:"已收票",colKey:"invoice_yes",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:false,isHideShowClickImg:true,isHideCanClickColor:true,isCanClickUnInclude:',0,'},
                    // {colName:"未收票",colKey:"invoice_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    // {colName:"优惠",colKey:"reduce_amount",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:false,isHideShowClickImg:true,isHideCanClickColor:true,isCanClickUnInclude:',0,'},
                    // // {colName:"发票状态",colKey:"already_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"采购人",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    // {colName:"采购类型",colKey:"purchase_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    // // {colName:"采购属性",colKey:"tax_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                selectRow: [],
                totalObj: {},
                filterDialogVisible: false,
                filterDialogVisibleB: false,
                filter: "",
                filters: [],
                copy_filter: "",
                fields: "",
                tableTotal: {
                    sales_amount: 0.00,
                    tax: 0.00,
                    discount_amount: 0.00,
                    tax_amount: 0.00,
                    traffic_amount: 0.00,
                    other_amount: 0.00,
                    reduce_amount: 0.00,
                    receivable_amount: 0.00,
                    invoice_no: 0.00,
                    invoice_yes: 0.00
                },
                purchaseStatusList: [],
                rec_params: {},
                recChanges: false,
                f_rec: '',
                otherVisible: false,
                reduceVisible: false,
                sure_params: {
                    order_id: "",
                    amount: "",
                    reduce_amount: "",
                    remark: ""
                },
                listDetailObj: {
                    id: "",
                    reduce_amount: "",
                    reduce_amount_remark: "",
                    other_amount: "",
                    other_amount_remark: "",
                },
                purchaseShow: false,
                addDepositDialog: false,//定金付款单弹框
                deposit_params: {
                    id: '',
                    contract_no: "",
                    trading_time: "",
                    account_id: "",
                    supplier_id: "",
                    payment_type_id: "",
                    bill_type: 1,
                    course_title: "采购定金",
                    currency_rate: "",
                    amount: "",
                    remark: "",
                    files: [],
                },
                addTailDepositDialog: false,//尾款付款单
                tailDeposit_params: {
                    ids: [],
                    contract_no: "",
                    trading_time: "",
                    account_id: "",
                    supplier_id: "",
                    payment_type_id: "",
                    bill_type: 1,
                    course_title: "采购尾款",
                    currency_rate: "",
                    amount: "",
                    remark: "",
                    files: [],
                },
                addSettlementDialog: false,//结算确认单
                settlement_params: {
                    type: 1,
                    amount: '',
                    remark: '',
                    currency_id: '',
                    currency_rate: '',
                },
                addOtherDepositDialog: false,//其他应付弹框
                otherDeposit_params: {
                    id: '',
                    contract_no: "",
                    trading_time: "",
                    account_id: "",
                    supplier_id: "",
                    payment_type_id: "",
                    bill_type: 1,
                    currency_rate: "",
                    amount: "",
                    remark: "",
                    files: [],
                },
                addDiscountDialog: false,//优惠弹框
                discount_params: {
                    id: '',
                    trading_time: '',
                    supplier_id: '',
                    // fee_id:'',
                    amount: '',
                    currency_id: '',
                    // currency_rate:'',
                    files: [],
                    remark: '',
                },
                specDetailFlag: false,//详细规格及采购单价弹框
                specDetail: [],
                cubeTotal: {},
                discountDetailFlag: false,//优惠赔偿弹框
                discountDetail: [],
                discountTotal: {},
                otherDetailFlag: false,//其他应付
                otherDetail: [],
                otherTotal: {},
                settlementDiscountDetailFlag: false,//已结优惠
                settlementDiscountDetail: [],
                settlementDiscountTotal: {},
                fileListShow: [],
                paymentAmount: '',//付款金额
                purchaseBalance: '',//采购金额
                reduceAmount: '',//优惠赔偿金
                amountPayable: "",//应付金额
                currencyDis: false,
                addDialogRules: {
                    account_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    payment_type_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    amount: [{ required: true, message: '不能为空', trigger: 'change' }],
                    currency_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                addRules: {
                    currency_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                isRenminbi: false,//判断是否有人民币
            }
        },
        created() {
            this.getSelectList("supplier")
            this.getSelectList("creater")
            this.getSelectList("payerList")
            this.getSelectList("currency")
            this.getSelectList("purchaseCost")
            this.getSelectList("settlementType")
            this.getPurchaseStatusList()
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods: {
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneIn).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getSelectsalePurchase(target) {
                this.$getSelectsalePurchase(target, { supplier_id: this.params.supplier_id, settlement_status: this.params.settlement_status }).then(res => {
                    this.selectMapS[res.data.data.target] = res.data.data.result;
                })
            },
            //点击付定金
            purchaseDeposit() {
                this.deposit_params.contract_no = this.form_params.contract_no;
                this.deposit_params.currency_id = this.form_params.foreign_currency_id == 0 ? '' : this.form_params.foreign_currency_id;
                this.currencyDis = this.form_params.foreign_currency_id == '' ? false : true;
                this.addDepositDialog = true;
                this.deposit_params.id = this.form_params.id;
                this.deposit_params.supplier_id = this.form_params.supplier_id;
                this.purchaseShow = true
            },
            //点击付尾款
            purchaseTail() {
                this.tailDeposit_params.contract_no = this.form_params.contract_no;
                this.tailDeposit_params.currency_id = this.form_params.foreign_currency_id == 0 ? '' : this.form_params.foreign_currency_id;
                this.currencyDis = this.form_params.foreign_currency_id == '' ? false : true;
                this.addTailDepositDialog = true;
                this.tailDeposit_params.ids = [this.form_params.id];
                this.tailDeposit_params.supplier_id = this.form_params.supplier_id;
                this.purchaseShow = true
            },
            //点击结算
            purchaseSettlement() {
                this.addSettlementDialog = true;
                this.settlement_params.ids = [this.form_params.id];
                this.settlement_params.currency_id = this.form_params.foreign_currency_id == 0 ? '' : this.form_params.foreign_currency_id;
                // this.purchaseBalance = this.form_params.fc_amount;
                this.amountPayable = this.form_params.fc_payment_amount;
                this.currencyDis = this.form_params.foreign_currency_id == '' ? false : true;
                this.purchaseShow = true;
                this.currencyChange();
            },
            //点击开发票
            openBill() {
                this.invoice_time = new Date();
                this.add_billParams.title = this.companyName;
                this.add_billParams.purchase_id = this.form_params.id;
                this.add_billParams.contract_no = this.form_params.contract_no;
                this.addDialogVisibleBill = !this.addDialogVisibleBill;
                this.selectMap.customer.forEach(item => {
                    if (item.id == this.form_params.customer_id) {
                        this.add_billParams.title = item.name;
                    }
                })
            },
            amend() {
                this.recChanges = !this.recChanges;
                this.f_rec = this.form_params.rec;
                // this.rec_params.tax_rate = this.form_params.tax_rate;
                this.rec_params.id = this.form_params.id;
            },
            outRecChanges() {
                this.recChanges = false;
            },
            settlementConfirm() {
                if (this.f_rec == true) {
                    this.f_rec = 'IS_REC'
                } else {
                    this.f_rec = 'NOT_REC'
                }
                this.rec_params.rec = this.f_rec
                this.postFunc('/erp/cloud.finance.purchase.rec', this.rec_params, () => {
                    this.outRecChanges();
                    this.tip("修改成功", "success");
                    this.postFuncLoading("/erp/cloud.finance.purchase.info", { id: this.rec_params.id }, res => {
                        this.form_params = res.data.data;
                        if (this.form_params.rec == 0) {
                            this.form_params.rec = false
                        } else {
                            this.form_params.rec = true
                        }
                        this.form_params.contract_time = res.data.data.contract_time * 1000;
                        this.supplier_balance = res.data.data.supplier_balance;
                        this.listDetail = res.data.data.details;
                        // this.newFee = res.data.data.list.fee_list;
                        this.sceneIn = 'cloud.finance.purchase.info';
                        this.isGlobal = true;
                        this.getBillColumn()
                        this.dialogVisible = true;
                        this.calculationTableTotal()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                })
            },
            //开发票
            addOrderBill() {
                this.$confirm('是否确认收票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_billParams.invoice_time = this.formatTimeZero(this.invoice_time)
                    this.postFuncLoading("/erp/cloud.purchase.invoice", this.add_billParams, () => {
                        this.tip("操作成功", "success")
                        this.addDialogVisibleBill = false;
                        // this.dialogVisible=false;
                        // this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //计算合计
            calculationTableTotal() {
                // return
                let sales_amount = 0;
                let discount_amount = 0;
                let tax_amount = 0;
                let traffic_amount = 0;
                let other_amount = 0;
                let reduce_amount = 0;
                // let receivable_amount = 0.00;
                if (this.listDetail.length > 0) {
                    this.listDetail.forEach(item => {
                        if (item.cube && item.cube_price) {
                            // sales_amount += this.keepPrice(Number(item.sales_cube)*Number(item.sales_price))
                            // sales_amount += Number(item.sales_cube)*Number(item.sales_price)
                            this.calcu(item.cube, item.cube_price, "mul", res => {
                                // this.pl(res)
                                item.total_amount = res;
                                this.calcu(sales_amount, res, "add", val => {
                                    sales_amount = val
                                }, 2)
                            }, 2)
                        }
                    })
                }
                if (this.form_params.rec == 1) {
                    this.calcu(sales_amount, discount_amount, "reduce", res => {
                        this.calcu(this.form_params.tax_rate, 100, "div", ret => {
                            this.calcu(res, ret, "mul", val => {
                                tax_amount = val
                            }, 2)
                        }, 4)
                    }, 2)
                    // tax_amount = this.keepPrice((sales_amount - discount_amount)*(Number(this.form_params.tax_rate)/100))
                } else {
                    tax_amount = 0
                }
                this.tableTotal.sales_amount = sales_amount;
                this.tableTotal.tax_amount = tax_amount;
                this.calcu(sales_amount, tax_amount, "add", a => {
                    this.tableTotal.receivable_amount = a;
                }, 2)
            },
            getPurchaseStatusList() {
                this.postFunc("/erp/cloud.purchase.status", {}, res => {
                    this.purchaseStatusList = res.data.data;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            getBill() {
                this.addDialogVisibleBill = true;
                this.add_billParams.id = this.form_params.id;
            },
            exportExcelBill() {
                this.$exportExecl("/erp/purchase.order.export", "采购单", { id: this.form_params.id })
            },
            //付款
            payFunc() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                }
                for (let i = 0; i < this.selectRow.length; i++) {
                    if (this.selectRow[0].supplier_id != this.selectRow[i].supplier_id) {
                        this.tip("付款，供应商必须相同！", "warning");
                        return
                    } else {
                        ids.push(this.selectRow[i].id);
                    }
                    num = i;
                }
                if (this.selectRow.length > 1) {
                    this.addDialogVisibleBack = true;
                    this.add_params.ids = ids;
                    this.add_params.supplier_id = this.selectRow[0].supplier_id;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.add_params.contract_no = this.selectRow[0].contract_no;
                    this.addDialogVisibleBack = true;
                    this.add_params.ids = ids;
                    this.add_params.supplier_id = this.selectRow[0].supplier_id;
                    this.purchaseShow = true
                }
            },
            //付定金
            payDeposit() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                } else if (this.selectRow.length > 1) {
                    this.tip("请选择单条数据", "warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if (this.selectRow.length > 1) {
                    this.addDepositDialog = true;
                    this.deposit_params.id = this.selectRow[0].id;
                    this.deposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.deposit_params.currency_id = this.selectRow[0].foreign_currency_id;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.deposit_params.contract_no = this.selectRow[0].contract_no;
                    this.addDepositDialog = true;
                    this.deposit_params.id = this.selectRow[0].id;
                    this.deposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.deposit_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.currencyDis = this.selectRow[0].foreign_currency_id == 0 ? false : true;
                    this.purchaseShow = true
                }
            },
            //定金付款确认
            addDepositBack() {
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deposit_params.trading_time = parseInt(this.trading_time.getTime() / 1000);
                    this.deposit_params.currency_rate = parseFloat(this.deposit_params.currency_rate);
                    this.postFuncLoading("/erp/cloud.finance.pay.deposit", this.deposit_params, () => {
                        this.tip("付款成功", "success")
                        this.addDepositDialog = false;
                        this.dialogVisible = false;
                        this.getList();
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //付尾款
            payTailDeposit() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                }
                for (let i = 0; i < this.selectRow.length; i++) {
                    if (this.selectRow[0].supplier_id != this.selectRow[i].supplier_id) {
                        this.tip("付款，供应商必须相同！", "warning");
                        return
                    } else {
                        ids.push(this.selectRow[i].id);
                    }
                    num = i;
                }
                if (this.selectRow.length > 1) {
                    this.addTailDepositDialog = true;
                    this.tailDeposit_params.ids = ids;
                    this.tailDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.tailDeposit_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.currencyDis = this.form_params.foreign_currency_id == '' ? false : true;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.tailDeposit_params.contract_no = this.selectRow[0].contract_no;
                    this.addTailDepositDialog = true;
                    this.tailDeposit_params.ids = ids;
                    this.tailDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.tailDeposit_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.currencyDis = this.selectRow[0].foreign_currency_id == 0 ? false : true;
                    this.purchaseShow = true
                }
            },
            //尾货付款确认
            addTailDepositBack() {
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.tailDeposit_params.trading_time = parseInt(this.trading_time.getTime() / 1000);
                    this.postFuncLoading("/erp/cloud.finance.pay.last", this.tailDeposit_params, () => {
                        this.tip("付款成功", "success")
                        this.addTailDepositDialog = false;
                        this.dialogVisible = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //结算
            settlement() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                }
                // else if(this.selectRow.length>1){
                //     this.tip("请选择单条数据","warning");
                //     return
                // }
                for (let i = 0; i < this.selectRow.length; i++) {
                    if (this.selectRow[0].supplier_id != this.selectRow[i].supplier_id) {
                        this.tip("结算，供应商必须相同！", "warning");
                        return
                    } else if (this.selectRow[0].foreign_currency_id != this.selectRow[i].foreign_currency_id) {
                        this.tip("结算，币种必须相同！", "warning");
                        return
                    }
                    else {
                        ids.push(this.selectRow[i].id);
                    }
                    num = i;
                }
                this.addSettlementDialog = true;
                this.settlement_params.ids = ids;
                this.currencyChange();
                this.purchaseShow = false
                this.settlement_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                this.currencyDis = this.selectRow[0].foreign_currency_id == 0 ? false : true;
            },
            //结算获取金额
            currencyChange() {
                let obj = {};
                if (this.dialogVisible == true) {
                    obj.ids = [this.form_params.id];
                } else {
                    obj.ids = this.settlement_params.ids;
                }
                if (this.settlement_params.type == 2) {
                    this.selectMap.currency.forEach(item => {
                        if (item.id == this.settlement_params.currency_id) {
                            var currency_name = item.name;
                            if (currency_name == '人民币') {
                                this.settlement_params.currency_rate = 1;
                                this.isRenminbi = true;
                            } else {
                                this.settlement_params.currency_rate = '';
                                this.isRenminbi = false;
                            }
                        }
                    })
                }
                // obj.type = this.settlement_params.type;
                // obj.currency_id = this.settlement_params.currency_id;
                this.postFunc("/erp/purchase.currency.amount", obj, res => {
                    this.purchaseBalance = res.data.data.purchase_balance;
                    this.amountPayable = res.data.data.amount;
                    this.reduceAmount = res.data.data.reduce_amount;
                    this.settlement_params.amount = res.data.data.amount;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            //结算确认
            addsettlementBack() {
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.settlement_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    if (this.settlement_params.type == 1) {
                        delete this.settlement_params.currency_rate;
                    }
                    this.postFuncLoading("/erp/cloud.finance.cope.settlement", this.settlement_params, () => {
                        this.tip("结算成功", "success")
                        this.addSettlementDialog = false;
                        this.dialogVisible = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //其他应付
            payOtherDeposit() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                } else if (this.selectRow.length > 1) {
                    this.tip("请选择单条数据", "warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if (this.selectRow.length > 1) {
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.otherDeposit_params.contract_no = this.selectRow[0].contract_no;
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.purchaseShow = true
                }
                this.currencyDis = this.selectRow[0].foreign_currency_id == 0 ? false : true;
            },
            //其他付款确认
            addotherDepositBack() {
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.otherDeposit_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    this.postFuncLoading("/erp/cloud.finance.pay.other", this.otherDeposit_params, () => {
                        this.tip("付款成功", "success")
                        this.addOtherDepositDialog = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //优惠/赔偿
            payDiscount() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                } else if (this.selectRow.length > 1) {
                    this.tip("请选择单条数据", "warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if (this.selectRow.length > 1) {
                    this.addDiscountDialog = true;
                    this.discount_params.id = this.selectRow[0].id;;
                    this.discount_params.supplier_id = this.selectRow[0].supplier_id;
                    this.discount_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.discount_params.contract_no = this.selectRow[0].contract_no;
                    this.addDiscountDialog = true;
                    this.discount_params.id = this.selectRow[0].id;;
                    this.discount_params.supplier_id = this.selectRow[0].supplier_id;
                    this.discount_params.currency_id = this.selectRow[0].foreign_currency_id == 0 ? '' : this.selectRow[0].foreign_currency_id;
                    this.purchaseShow = true
                }
                this.currencyDis = this.selectRow[0].foreign_currency_id == 0 ? false : true;
            },
            //优惠/赔偿确认
            addDiscountBack() {
                this.$confirm('是否确认添加?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.discount_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    this.postFuncLoading("/erp/cloud.finance.pay.reduce", this.discount_params, () => {
                        this.tip("操作成功", "success")
                        this.addDiscountDialog = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            excelExport() {
                this.$exportExecl("/erp/cloud.finance.payments.excel", "应付汇总", this.params)
            },
            print(type) {
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + type;
                window.open(url);
            },
            filterConfirm() {
                if (this.isGlobal) {
                    this.getBillColumn()
                } else {
                    this.getList()
                }
            },
            getBillColumn() {
                if (this.isGlobal) {
                    this.filters = []
                    this.postFunc("/erp/company.column.data", { scene: this.sceneIn }, response => {
                        this.billColumn = "," + response.data.data.fields.join(",").toString() + ",";
                        this.filters = response.data.data.columns;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                } else {
                    this.postFunc("/erp/company.column.data", { scene: this.scene }, response => {
                        this.billColumn = "," + response.data.data.fields.join(",").toString() + ",";
                        this.filter = response.data.data.columns;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }
            },
            getSelectList(target) {
                this.$getSelectList(target).then(res => {
                    this.selectMap[res.target] = res.list;
                })
            },
            changeRate(e, input) {
                e.target.value = (e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})", "g"))[0]) || null
                this.input = e.target.value
                this.add_params.amount = this.input
            },
            // 付款金额计算
            AmountCalculation(e, value) {
                if (value == '') {
                    value = 1
                }
                this.paymentAmount = this.keepPrices(this.$bc_mul(e, value))
            },
            //添加付款单
            addOrderSheetBack() {
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    this.postFuncLoading("/erp/cloud.finance.pay.amount", this.add_params, () => {
                        this.tip("付款成功", "success")
                        this.addDialogVisibleBack = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            getRow(row) {
                this.selectRow = row;
            },
            selectAccount(val) {
                this.selectMap.account.forEach(item => {
                    if (item.id == val) {
                        this.form_params.bank_no = item.bank_no;
                        this.form_params.account_name = item.account_name;
                        this.form_params.bank_name = item.bank_name;
                    }
                })
            },
            rowClick(obj) {
                this.listDetailObj.id = obj.id;
                if (obj.name == "see") {
                    sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_ID")
                    sessionStorage.setItem("DEMU_ERP_PAYSUMMARY_ID", obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情' + obj.id,
                        label: '明细详情',
                        content: 'paySummaryDetail'
                    });
                } else if (obj.name == "invoice_yes") {
                    this.seeBillList_id = obj.id;
                    this.dialogVisibleBill = true;
                } else if (obj.name == "contract_no") {
                    this.postFuncLoading("/erp/cloud.finance.purchase.info", { id: obj.id }, res => {
                        this.form_params = res.data.data;
                        if (this.form_params.rec == 0) {
                            this.form_params.rec = false
                        } else {
                            this.form_params.rec = true
                        }
                        this.form_params.contract_time = res.data.data.contract_time * 1000;
                        this.listDetail = res.data.data.details;
                        this.supplier_balance = res.data.data.supplier_balance;
                        // this.newFee = res.data.data.fee_list;
                        this.sceneIn = 'cloud.finance.purchase.info';
                        this.isGlobal = true;
                        this.getBillColumn()
                        this.dialogVisible = true;
                        // this.calculationTableTotal()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }
                // else if(obj.name == "other_amount"){
                //     //其他收款
                //     this.listDetailObj.other_amount=obj.row.other_amount;
                //     this.listDetailObj.other_amount_remark=obj.row.other_amount_remark;
                //     this.otherVisible =true;
                // }
                else if (obj.name == "reduce_amount") {
                    //优惠
                    this.listDetailObj.reduce_amount = obj.row.reduce_amount;
                    this.listDetailObj.reduce_amount_remark = obj.row.reduce_amount_remark;
                    this.reduceVisible = true;
                } else if (obj.name == "foreign_total_amount") {
                    //外币码单金额
                    this.postFuncLoading('/erp/cloud.finance.spec.detail', { id: obj.id }, res => {
                        this.specDetail = res.data.data.list;
                        this.cubeTotal = res.data.data.total;
                        this.specDetailFlag = true;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                } else if (obj.name == "fc_reduce_amount") {
                    //优惠/赔偿
                    this.postFuncLoading('/erp/cloud.finance.reduce.list', { id: obj.id }, res => {
                        this.discountDetail = res.data.data.list;
                        this.discountDetail.forEach((item, index) => {
                            item.fc_currency_unit = item.fc_currency_unit + item.fc_amount;
                            if (item.fee_date != 0) {
                                this.discountDetail[index].fee_date = this.formatTime(item.fee_date + "000")
                            } else {
                                this.discountDetail[index].fee_date = "";
                            }
                        })
                        this.discountTotal = res.data.data.total;
                        this.discountDetailFlag = true;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                } else if (obj.name == 'settlement_reduce') {
                    //已结优惠/赔偿
                    this.postFuncLoading('/erp/purchase.settlement.reduce.list  ', { id: obj.id }, res => {
                        this.settlementDiscountDetail = res.data.data.list;
                        this.settlementDiscountDetail.forEach((item, index) => {
                            item.fc_currency_unit = item.fc_currency_unit + item.fc_amount;
                            if (item.trading_time != 0) {
                                this.settlementDiscountDetail[index].trading_time = this.formatTime(item.trading_time + "000")
                            } else {
                                this.settlementDiscountDetail[index].trading_time = "";
                            }
                        })
                        this.settlementDiscountTotal = res.data.data.total;
                        this.settlementDiscountDetailFlag = true;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                } else if (obj.name == "fc_other_amount" || obj.name == "other_amount") {
                    //其他应付详情
                    this.postFuncLoading('/erp/cloud.finance.other.list', { id: obj.id }, res => {
                        this.otherDetail = res.data.data.list;
                        this.otherDetail.forEach((item, index) => {
                            item.currency_unit = item.currency_unit + item.inout_amount;
                            if (item.trading_time != 0) {
                                this.otherDetail[index].trading_time = this.formatTime(item.trading_time + "000")
                            } else {
                                this.otherDetail[index].trading_time = "";
                            }
                        })
                        this.otherTotal = res.data.data.total;
                        this.otherDetailFlag = true;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }
            },
            //优惠详情删除
            discountDetailDelete(index, id) {
                this.$confirm('确认是否删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.discountDetail.splice(index, 1);
                    // this.discountDetail.forEach(item=>{
                    //     this.discountTotal.fc_amount = this.keepPrices(this.$bc_add(item.fc_amount))
                    //     this.discountTotal.amount = this.keepPrices(this.$bc_add(item.amount))
                    // })
                    // console.log(this.discountTotal.fc_amount,99)
                    // return
                    this.postFunc('/erp/finance.purchase.reduce.delete', { id: id }, () => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.discountDetail.splice(index, 1);
                        this.discountDetailFlag = false;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            settlementDiscountDetailDelete() {

            },
            //其他应付详情删除
            otherDetailDelete(index, id) {
                this.$confirm('确认是否删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc('/erp/finance.purchase.other.delete', { id: id }, () => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.otherDetail.splice(index, 1);
                        this.otherDetailFlag = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            getPage(obj) {
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },

            getList(flag) {
                if (flag) {
                    this.params.page = 1;
                }
                this.params.start_time = this.formatTimeZero(this.start_time);
                this.params.end_time = this.formatTimeZero(this.end_time);
                this.params.arrival_start_time = this.formatTimeZero(this.arrival_start_time);
                this.params.arrival_end_time = this.formatTimeZero(this.arrival_end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/cloud.finance.payments", this.params, response => {
                    this.last_page = parseInt(response.data.data.list.last_page);
                    // this.params.page=parseInt(response.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total = parseInt(response.data.data.list.total);
                    this.list = response.data.data.list.data;
                    this.totalObj = response.data.data.total;
                    this.list.forEach((item, index) => {
                        item.see = "明细详情";
                        if (item.contract_time != 0) {
                            this.list[index].contract_time = this.formatTime(item.contract_time + "000")
                        } else {
                            this.list[index].contract_time = "";
                        }
                        if (item.expected_arrival_time != 0) {
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time + "000")
                        } else {
                            this.list[index].expected_arrival_time = "";
                        }
                        item.isCanClickUnInclude = item.invoice_yes;
                        if (Number(item.foreign_total_amount) == Number(item.fc_settlement_amount)) {
                            this.list[index].baseColor = "";
                        } else {
                            this.list[index].baseColor = "#ff0000";
                        }
                        if (item.foreign_total_amount == 0 || item.foreign_total_amount == null) {
                            this.list[index].baseColor = "#ff9100";
                        }
                    })
                    this.last_page = response.data.data.list.last_page;
                    this.filter = response.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(response.data.data.column))
                    this.fields = "," + (response.data.data.fields.join(",")).toString() + ",";
                    this.tableCol.forEach(item => {
                        if (this.fields.indexOf("," + item.colKey + ",") != -1) {
                            item.isShow = true;
                        } else {
                            item.isShow = false;
                        }
                        if (item.colKey == "see") {
                            item.isShow = true;
                        }
                    })
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            changeOther(e, input) {
                e.target.value = (e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})", "g"))[0]) || null
                this.input = e.target.value
                this.listDetailObj.other_amount = this.input
            },
            changeReduce(e, input) {
                e.target.value = (e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})", "g"))[0]) || null
                this.input = e.target.value
                this.listDetailObj.reduce_amount = this.input
            },
            outOtherVisible() {
                this.otherVisible = false;
                this.listDetailObj.other_amount = '';
            },
            outReduceVisible() {
                this.reduceVisible = false;
                this.listDetailObj.reduce_amount = '';
            },
            //其他修改
            otherChangeSure() {
                this.postFunc("/erp/cloud.finance.purchase.update", {
                    id: this.listDetailObj.id,
                    other_amount: this.listDetailObj.other_amount,
                    other_amount_remark: this.listDetailObj.other_amount_remark
                }, () => {
                    this.tip("修改成功", "success")
                    this.getList();
                    this.outOtherVisible();
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            //优惠修改
            reduceChangeSure() {
                this.postFunc("/erp/cloud.finance.purchase.update", {
                    id: this.listDetailObj.id,
                    reduce_amount: this.listDetailObj.reduce_amount,
                    reduce_amount_remark: this.listDetailObj.reduce_amount_remark
                }, () => {
                    this.tip("修改成功", "success")
                    this.getList();
                    this.outReduceVisible();
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            search() {
                if (this.params.page == 1) {
                    this.getList()
                } else {
                    this.params.page = 1;
                }
            },

            reset() {
                this.start_time = "";
                this.end_time = "";
                this.arrival_start_time = "";
                this.arrival_end_time = "";
                this.params = this.resetSearch(this.params)
                this.getList();
            },
            //打印
            print() {
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + 5;
                window.open(url);
            },
            change(e) {
                this.$forceUpdate()
            }
        },
        watch: {
            "params.page": function () {
                this.getList();
            },
            "params.per_page": function () {
                this.getList();
            },
            "addDialogVisibleBack": function (val) {
                if (!val) {
                    this.trading_time = new Date();
                    this.add_params = { ids: [], trading_time: "", account_name: "", supplier_id: "", payment_type_id: "", bill_type: 1, course_title: "采购贷款", amount: "", is_invoice: "", remark: "" }
                }
            },
            "dialogVisible": function (val) {
                if (!val) {
                    this.form_params = { id: "", auditor_name: "", contract_no: "", contract_time: "", creator_name: "", cube: "", details: [], order_count: "", remarks: [], supplier: "" };
                    this.listDetail = [];
                }
            },
            "addDialogVisibleBill": function (val) {
                if (!val) {
                    // this.add_billParams = {id:"",invoice_yes:""}
                    this.add_billParams = { invoice_time: "", title: "", purchase_id: "", contract_no: "", name: "增值税专用发票", code: "", amount: "", remark: "" }
                }
            },
            "addDepositDialog": function (val) {//定金
                if (!val) {
                    // this.deposit_params = this.resetJson(this.initDeposit_params);
                    this.deposit_params = {
                        id: '',
                        contract_no: "",
                        trading_time: "",
                        account_id: "",
                        supplier_id: "",
                        payment_type_id: "",
                        bill_type: 1,
                        course_title: "采购定金",
                        currency_rate: "",
                        amount: "",
                        remark: "",
                        files: [],
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                }
            },
            "addTailDepositDialog": function (val) {//尾款
                if (!val) {
                    this.tailDeposit_params = {
                        ids: [],
                        contract_no: "",
                        trading_time: "",
                        account_id: "",
                        supplier_id: "",
                        payment_type_id: "",
                        bill_type: 1,
                        course_title: "采购尾款",
                        currency_rate: "",
                        amount: "",
                        remark: "",
                        files: [],
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                }
            },
            "addSettlementDialog": function (val) {//结算
                if (!val) {
                    this.settlement_params = this.resetJson(this.settlement_params);
                    this.settlement_params.type = 1;
                    this.paymentAmount = '';
                    this.purchaseBalance = null;
                    this.amountPayable = null;
                    this.isRenminbi = false;
                }
            },
            "addOtherDepositDialog": function (val) {//其他
                if (!val) {
                    this.otherDeposit_params = {
                        id: '',
                        contract_no: "",
                        trading_time: "",
                        account_id: "",
                        supplier_id: "",
                        payment_type_id: "",
                        bill_type: 1,
                        currency_rate: "",
                        amount: "",
                        remark: "",
                        files: [],
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                }
            },
            "addDiscountDialog": function (val) {//优惠赔偿
                if (!val) {
                    this.discount_params = {
                        id: '',
                        trading_time: '',
                        supplier_id: '',
                        fee_id: '',
                        amount: '',
                        currency_id: '',
                        currency_rate: '',
                        files: [],
                        remark: '',
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                }
            },
            "discountDetailFlag": function (val) {//优惠赔偿详情窗口
                if (!val) {
                    this.getList();
                }
            },
            "settlementDiscountDetailFlag": function (val) {//已结优惠赔偿详情窗口
                if (!val) {
                    this.getList();
                }
            },
            "otherDetailFlag": function (val) {//其他应付详情窗口
                if (!val) {
                    this.getList();
                }
            }
        }
    }
</script>